import CasTextField, { ICasTextField } from './CasTextField';

export default function CasNumberField(props: ICasTextField) {
  return <CasTextField type='number' {...props} />;
}
